

import { toast } from 'react-toastify';
import API from "../lib/api"

export function pushQueuedChat(data){
    return function(dispatch,getState){
        const state=getState();
        dispatch({
            type: "PUSH_QUEUED_CHAT",
            data: data.chat,
            dispatch:dispatch
        });

        var activeChatsCopy =Object.values(state.chatprop.activeChats);
        if(typeof activeChatsCopy.find(chat=>chat.id==data.chat.id)==="undefined") {
            dispatch({
                type: "SET_SOUND",
                data: {
                    playing: true,
                    type: "queuedVisitor"
                }
            });
        }
    }
}

export function stopSuperViseChat(id){
    return function(dispatch,state){
        NODECONNECT.socket.emit("stopSuperViseChat",{"i":id});
    }
}
export function superViseChat(id){
    return function(dispatch,state){
        NODECONNECT.socket.emit("superViseChat",{"i":id});
    }
}

export function pickFromQueue(id){

    return function(dispatch,state){
        NODECONNECT.socket.emit("pickFromQueue",{"i":id});
    }

}
export function getSettings(){
    return function (dispatch, getState) {

        var formData = new FormData();

        API.post("settings",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.error!=="undefined"){
                    response.data.message.error.forEach(msg=>{
                        toast.error(msg);
                    });
                }
            }
        });
    }
}

export function logout(){
    return function (dispatch, getState) {

        var formData = new FormData();

        API.post("logout",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.error!=="undefined"){
                    response.data.message.error.forEach(msg=>{
                        toast.error(msg);
                    });
                }
            }
        });
    }
}
export function savePreChatForm(data){
        return function(dispatch,getState){
            var formData = new FormData();
            formData.append("data", data.formjson);
            API.post("save-prechat-form",formData).then((response) => {
                if (response.status === 200) {
                    if(typeof response.data.message.success!=="undefined"){
                        response.data.message.success.forEach(msg=>{
                            toast.success(msg);
                        });

                    }
                    if(typeof response.data.message.error!=="undefined"){
                        response.data.message.error.forEach(msg=>{
                            toast.error(msg);
                        });
                    }
                }
            });
        }
}
export function cannedResponse(data){
    return function (dispatch, getState) {

        var formData = new FormData();
        formData.append("action", data.action);
        if(data.action=="add" || data.action=="update"){
            formData.append("shortcut", data.shortcut);
            formData.append("desc", data.desc);
        }
        if(data.action=="update" || data.action=="delete"){
            formData.append("id", data.id);
        }

        API.post("canned-response",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.success!=="undefined"){
                    response.data.message.success.forEach(msg=>{
                        toast.success(msg);
                    });
                    if(data.action=="add"){
                        dispatch({
                            type: 'SET_CANNED_RESPONSE',
                            data: response.data.message.data
                        });

                    }
                    if(data.action=="delete"){
                        dispatch({
                            type: 'DELETE_CANNED_RESPONSE',
                            data: {id: data.id, filter_key: "id"}
                        });
                    }
                    if(data.action=="update"){
                        dispatch({
                            type: 'UPDATE_CANNED_RESPONSE',
                            data: {
                                id: data.id, filter_key: "id", up: response.data.message.data
                            }
                        });
                    }
                }
                if(typeof response.data.message.error!=="undefined"){
                    response.data.message.error.forEach(msg=>{
                        toast.error(msg);
                    });
                }
            }
        });
    }
}

export function changeSetting(data){
    return function (dispatch, getState) {

        var formData = new FormData();

       if(Object.keys(data).length>0){
           for (const [key, value] of Object.entries(data)) {
               formData.append(key, value);
           }

           API.post("save_setting",formData).then((response) => {
               if (response.status === 200) {
                   if(typeof response.data.message.success!=="undefined"){
                       response.data.message.success.forEach(msg=>{
                           toast.success(msg);
                       });
                        dispatch({
                           type: 'SET_SETTINGS',
                           data: response.data.message.data
                       });
                   }
                   if(typeof response.data.message.error!=="undefined"){
                       response.data.message.error.forEach(msg=>{
                           toast.error(msg);
                       });
                   }

               }
           });
       }

    }
}
export function sendMessage(data) {

    return function (dispatch, getState) {
		
		if(data.message !== "" || data.file !== ""){

        var formData = new FormData();
        formData.append("chat_id", data.chat_id);
        formData.append("message", data.message);
		if(data.file !== ""){
			formData.append("file", data.file);
		}
        API.post("chat/send_message",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.success!=="undefined"){

                    NODECONNECT.socket.emit("agent_send_message",response.data.message.data);

                }
                if(typeof response.data.message.error!=="undefined"){
                    response.data.message.error.forEach(msg=>{
                        toast.error(msg);
                    });
                }

            }
        });
		
		}
    }

}
export function sendTransfer(data) {

    return function (dispatch, getState) {

        var formData = new FormData();
        formData.append("chat_id", data.chat_id);
        formData.append("agent_id", data.agent_id);


        API.post("chat/transfer",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.success!=="undefined"){
                    response.data.message.success.forEach(msg=>{
                        toast.success(msg);
                    });
                    NODECONNECT.socket.emit("transfer",{"i":data.chat_id});
                    dispatch({
                        type: 'SET_MODAL',
                        data: {
                            "show": false,
                            "page": ""
                        }
                    });
                }
                if(typeof response.data.message.error!=="undefined"){
                    response.data.message.error.forEach(msg=>{
                        toast.error(msg);
                    });
                }

            }
        });

    }

}

export function closeChat(data){
    return function (dispatch,getState){

        var formData = new FormData();
        formData.append("id", data.id);


        API.post("chat/close",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.success!=="undefined"){

                    if(typeof response.data.message.data.closed!=="undefined"){
                        if(typeof response.data.message.data.chat_id!=="undefined"){
                            if(response.data.message.data.closed==2){
                                NODECONNECT.socket.emit("close_chat_agent_emit",response.data.message.data.chat_id);
                            } else{
                                dispatch({
                                    type: "DELETE_ACTIVE_CHAT",
                                    data: {id:data.id,filter_key:"id"}
                                });
                            }
                        }
                    } 

                }
                if(typeof response.data.message.error!=="undefined"){
					
								dispatch({
                                    type: "DELETE_ACTIVE_CHAT",
                                    data: {id:data.id,filter_key:"id"}
                                });
								
								
                    response.data.message.error.forEach(msg=>{
                     //   toast.error(msg);
                    });
                }

            }
        });

    }
}

export function userBan(data){
    return function (dispatch,getState){

        var formData = new FormData();
        formData.append("id", data.id);


        API.post("chat/ban",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.success!=="undefined"){

                        if(typeof response.data.message.data.chat_id!=="undefined"){
							NODECONNECT.socket.emit("userBanned", response.data.message.data.user_socket);
                        }

                }
                if(typeof response.data.message.error!=="undefined"){
                    response.data.message.error.forEach(msg=>{
                        toast.error(msg);
                    });
                }

            }
        });

    }
}
export function editDepartment(data){
    return function(dispatch,getState) {

        var formData = new FormData();
        formData.append("id", data.id);
        if(typeof data.checked!=="undefined"){
            if(data.checked===false){
                var status=2;
            }else{
                var status=1;
            }
            formData.append("checked", status);
        }
        if(typeof data.department_name!=="undefined"){
            formData.append("department_name", data.department_name);
        }

        var action="edit";
        var url="";
        if(typeof data.action!=="undefined"){
            if(data.action=="remove"){
                action="remove";

            }
        }
        if(action=="edit"){
             url="departments/edit";
        }
        if(action=="remove"){
            url="departments/delete";
        }



        API.post(url,formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.success!=="undefined"){

                    if(action=="edit") {

                        NODECONNECT.socket.emit("updateDepartment",{id: data.id});
                        dispatch({
                            type: 'SET_MODAL',
                            data: {
                                "show": false,
                                "page": ""
                            }
                        });
                    } else{
                        NODECONNECT.socket.emit("updateDepartment",{id: data.id});
                        NODECONNECT.socket.emit("newDepartment");
                    }
                    response.data.message.success.forEach(msg=>{
                        toast.success(msg);
                    });
                }
                if(typeof response.data.message.error!=="undefined"){
                    response.data.message.error.forEach(msg=>{
                        toast.error(msg);
                    });
                }

            }
        });

    }
}
export function removeAgents(uid){
    return function(dispatch,getState) {

        var formData = new FormData();
        formData.append("user_id", uid);

        API.post("agents/remove",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.success!=="undefined"){
                    NODECONNECT.socket.emit("newAgent");
                    NODECONNECT.socket.emit("operatorDeleted",uid);

                    response.data.message.success.forEach(msg=>{
                        toast.success(msg);
                    });
                }
                if(typeof response.data.message.error!=="undefined"){
                    response.data.message.error.forEach(msg=>{
                        toast.error(msg);
                    });
                }

            }
        });

    }
}

export function removeBannedUser(id){
    return function(dispatch,getState) {

        var formData = new FormData();
        formData.append("id", id.id);

        API.post("bannedUser/remove",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.success!=="undefined"){
                    NODECONNECT.socket.emit("bannedUser");

                    response.data.message.success.forEach(msg=>{
                        toast.success(msg);
                    });
                }
                if(typeof response.data.message.error!=="undefined"){
                    response.data.message.error.forEach(msg=>{
                        toast.error(msg);
                    });
                }

            }
        });

    }
}

export function allBannedUser(){
    return function(dispatch,getState) {
		var formData = new FormData();
        API.post("bannedUser/list/datatable",formData).then((response) => {
            if (response.status === 200) {
                        if(typeof response.data!=="undefined"){
							dispatch({
                        type: 'SET_BANNED_USERS',
                        data: response.data
                    });
                        }
            }
        });
    }
}


export function addDepartment(data){
    return function(dispatch,getState) {

        var formData = new FormData();
        formData.append("department_name", data.department_name);


        API.post("departments/add",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.success!=="undefined"){
                    dispatch({
                        type: 'SET_MODAL',
                        data: {
                            "show":false,
                            "page":""
                        }
                    });
                    NODECONNECT.socket.emit("updateDepartment", 1);
                    NODECONNECT.socket.emit("newDepartment");

                    response.data.message.success.forEach(msg=>{
                        toast.success(msg);
                    });
                }
                if(typeof response.data.message.error!=="undefined"){
                    response.data.message.error.forEach(msg=>{
                        toast.error(msg);
                    });
                }

            }
        });

    }
}
export function saveChatLimitForAgent(data){
    return function(dispatch,getState) {
        const state=getState();
        const defaultHeaders = {
            'content-type' : 'application/x-www-form-urlencoded',
        }
        var formData = new FormData();
        formData.append("user", data.id);
        formData.append("limit", data.amount);

        API.post("agents/setChatLimit",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.success!=="undefined"){

                    if(typeof response.data.message.changed!=="undefined"){
                        NODECONNECT.socket.emit("chatLimitChanged");
                    }
                    NODECONNECT.socket.emit("updateAgent", {id: data.id,o:1});

                    response.data.message.success.forEach(msg=>{
                        toast.success(msg);
                    });
                }
                if(typeof response.data.message.error!=="undefined"){
                    response.data.message.error.forEach(msg=>{
                        toast.error(msg);
                    });
                }

            }
        });

    }
}



export function editAgent(data){
    return function(dispatch,getState) {

        var formData = new FormData();
        formData.append("email", data.email);
        formData.append("id", data.id);
        formData.append("namesurname", data.namesurname);

        formData.append("departmentArr", JSON.stringify(data.department));
        if(typeof data.phoneNumber!=="undefined"){
            formData.append("phoneNumber", data.phoneNumber);
        }
        if(typeof data.password!=="undefined"){
            formData.append("password", data.password);
        }
        if(typeof data.role!=="undefined"){
            formData.append("role", data.role);
        }

        API.post("agents/edit",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.success!=="undefined"){
                    NODECONNECT.socket.emit("updateDepartment",1);
                    NODECONNECT.socket.emit("updateAgent", {id: data.id});

                    dispatch({
                        type: 'SET_MODAL',
                        data: {
                            "show":false,
                            "page":""
                        }
                    });
                    response.data.message.success.forEach(msg=>{
                        toast.success(msg);
                    });
                }
                if(typeof response.data.message.error!=="undefined"){
                    response.data.message.error.forEach(msg=>{
                        toast.error(msg);
                    });
                }

            }
        });

    }
}
export function addAgent(data){
    return function(dispatch,getState) {

        var formData = new FormData();
        formData.append("email", data.email);
        formData.append("namesurname", data.namesurname);
        formData.append("password", data.password);
        formData.append("role", data.role);
        formData.append("departmentArr", JSON.stringify(data.department));
        if(typeof data.phoneNumber!=="undefined"){
            formData.append("phoneNumber", data.phoneNumber);
        }

        API.post("agents/add",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.success!=="undefined"){
                    NODECONNECT.socket.emit("newAgent");
                    dispatch({
                        type: 'SET_MODAL',
                        data: {
                            "show":false,
                            "page":""
                        }
                    });
                    response.data.message.success.forEach(msg=>{
                        toast.success(msg);
                    });
                }
                if(typeof response.data.message.error!=="undefined"){
                    response.data.message.error.forEach(msg=>{
                        toast.error(msg);
                    });
                }

            }
        });

    }
}
export function changeAutoAssignment(id,checked){
    return function(dispatch,getState) {
        if(checked===false){
            var status=0;
        }else{
            var status=1;
        }
        var formData = new FormData();
        formData.append("status", status);
        formData.append("user", id);

        API.post("agents/setAssignment",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.success!=="undefined"){
                    NODECONNECT.socket.emit("updateAgent",{id:id,o:1});
                    response.data.message.success.forEach(msg=>{
                        toast.success(msg);
                    });

                }
                if(typeof response.data.message.error!=="undefined"){
                    response.data.message.error.forEach(msg=>{
                        toast.error(msg);
                    });
                }

            }
        });


    }

}
export function changeUserState(id,checked){
    return function(dispatch,getState) {

        if(checked===false){
            var checkedState=2;
        }else{
            var checkedState=1;
        }
        var formData = new FormData();
        formData.append("checked", checkedState)
        formData.append("id", id);
        API.post("agents/edit/state",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.success!=="undefined"){
                   // NODECONNECT.socket.emit("operatorChangeState",response.data.message.data);
                    NODECONNECT.socket.emit("updateAgent",{id:id,o:1,s:1});

                    response.data.message.success.forEach(msg=>{
                        toast.success(msg);
                    });


                }
                if(typeof response.data.message.error!=="undefined"){
                    response.data.message.error.forEach(msg=>{
                        toast.error(msg);
                    });
                }



            }
        });
    }

}

export function setAway(checkedState){
    return function(dispatch,getState) {


        if(checkedState){
            var checked=1;
        } else{
            var checked=0;
        }
        var formData = new FormData();
        formData.append("checked", checked);

        API.post("user/away",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.success!=="undefined"){
                    NODECONNECT.socket.emit("away",checked);
                    dispatch({
                        type: 'SET_OPERATOR',
                        data: {away:checked}
                    });

                }
            }
        });
    }

}

export function setDarkMode(checkedState){
    return function(dispatch,getState) {


        if(checkedState){
            var checked=1;
        } else{
            var checked=0;
        }
        var formData = new FormData();
        formData.append("checked", checked);

        API.post("user/dark_mode",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.success!=="undefined"){
                    
					window.location.reload(false);

                }
            }
        });
    }

}

export function setAvatar(cat,file,id){
    return function(dispatch,getState) {

        var formData = new FormData();
        formData.append("file",file);
        formData.append("cat",cat);
        formData.append("id",id);

        API.post("agents/setAvatar",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data!=="undefined"){
                    if(typeof response.data.message.success!=="undefined"){

                        NODECONNECT.socket.emit("updateAgent",{id:id});

                        response.data.message.success.forEach(msg=>{
                            toast.success(msg);
                        });
                        dispatch({
                            type: 'SET_MODAL',
                            data: {
                                "show":false,
                                "page":""
                            }
                        });

                    }
                    if(typeof response.data.message.error!=="undefined"){
                        response.data.message.error.forEach(msg=>{
                            toast.error(msg);
                        });
                    }

                }

            }
        });
    }
}
export function avatarFileUpload(file,id){
    return function(dispatch,getState) {

        var formData = new FormData();
        formData.append("file",file);
        formData.append("type","up");
        formData.append("id",id);

        API.post("agents/setAvatar",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data!=="undefined"){
                    if(typeof response.data.message.success!=="undefined"){

                         NODECONNECT.socket.emit("updateAgent",{id:id});

                        response.data.message.success.forEach(msg=>{
                            toast.success(msg);
                        });


                    }
                    if(typeof response.data.message.error!=="undefined"){
                        response.data.message.error.forEach(msg=>{
                            toast.error(msg);
                        });
                    }

                }

            }
        });
    }
}
export function allDepartments(){
    return function(dispatch,getState) {

        API.post("departments/list/datatable",{}).then((response) => {
            if (response.status === 200) {
                if(typeof response.data!=="undefined"){
                    dispatch({
                        type: 'SET_ALL_DEPARTMENTS',
                        data: response.data
                    });

                }

            }
        });
    }
}

export function allAgents(){
    return function(dispatch,getState) {

        API.post("agents/list/datatable",{}).then((response) => {
            if (response.status === 200) {
                if(typeof response.data!=="undefined"){
                    dispatch({
                        type: 'SET_ALL_AGENTS',
                        data: response.data
                    });

                }

            }
        });
    }
}

export function getArchiveChat(data) {
    return   function(dispatch,getState) {


        API.post("getArchiveChat",{}).then((response) => {
            if(response.status===200) {
                if (typeof response.data !== "undefined") {
                    dispatch({
                        type: 'SET_ALL_ARCHIVE',
                        data: response.data
                    });
                    dispatch({
                        type: 'ARCHIVE_ACTIVE',
                        data: true
                    });

                }
            }
        });

    }
}

export function initialState() {
    return function(dispatch,getState) {

        API.post("initialState",{}).then((response) => {
            if(response.status===200) {
                if (typeof response.data !== "undefined") {

                    if(typeof response.data.departments!=="undefined"){
                        dispatch({
                            type: 'SET_ALL_DEPARTMENTS',
                            data: response.data.departments
                        });
                    }

                    if(typeof response.data.menu!=="undefined"){
                        dispatch({
                            type: 'SET_LEFT_MENU',
                            data: response.data.menu
                        });
                    }

                    if(typeof response.data.license_number!=="undefined"){

                        dispatch({
                            type: 'SET_LICENSE_NUMBER',
                            data: response.data.license_number
                        });
                    }
                    if(typeof response.data.active_chats!=="undefined"){

                        dispatch({
                            type: 'SET_ACTIVE_CHAT',
                            data: response.data.active_chats
                        });
                    }
                    if(typeof response.data.operator!=="undefined"){

                        dispatch({
                            type: 'SET_OPERATOR',
                            data: response.data.operator
                        });
                    }
					
					if (typeof response.data.bannedUsers !== "undefined") {
                                    this.props.dispatch({
                                        type: 'SET_BANNED_USERS',
                                        data: response.data.bannedUsers
                                    });
                                }

                    dispatch({
                        type: 'SET_PROCESS',
                        data: true
                    });
                }
            }
        });


    }
}

